import React, { useEffect } from 'react';
import Header from '../../components/Header/Header';
import CarouselTop from '../../components/CarouselTop/CarouselTop';
import About from '../../components/About/About';
import Gallery from '../../components/Gallery/Gallery';
import ResortInfo from '../../components/ResortInfo/ResortInfo';
import AvailableDates from '../../components/AvailableDates/AvailableDates';
import './HomePage.scss';
import '../../components/Table/Table.scss';
import "react-image-gallery/styles/scss/image-gallery.scss";

const HomePage = (props) => {

  useEffect(() => {
    const section = document.getElementById(props.location.pathname.substr(1))
    if(section) {
      section.scrollIntoView({behavior: "smooth"})
    } else {
      document.getElementById("home").scrollIntoView({behavior: "smooth"})
    }
  }, [props.location]) // Fires when component mounts and every time hash change

  return (
    <div id="home">
      <Header />
      <CarouselTop />
      <div className="homepage">
        <section id="about"><About /></section>
        <section id="gallery"><Gallery /></section>
        <section id="resortinfo"><ResortInfo /></section>
        <section id="availabledates"><AvailableDates /></section>
      </div>
    </div>
  );
}

export default HomePage;